"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoDestination = void 0;
var tslib_1 = require("tslib");
var destination_1 = require("../base/destination");
var legacy_password_hash_destination_1 = require("../protection/legacy-password-hash-destination");
var password_hash_destination_1 = require("../protection/password-hash-destination");
var destination_type_1 = require("../utils/destination-type");
var InfoDestination = (function (_super) {
    tslib_1.__extends(InfoDestination, _super);
    function InfoDestination() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(InfoDestination.prototype, "destinationType", {
        get: function () { return destination_type_1.DestinationType.InfoDestination; },
        enumerable: false,
        configurable: true
    });
    ;
    Object.defineProperty(InfoDestination.prototype, "controlCharHT", {
        get: function () { return null; },
        enumerable: false,
        configurable: true
    });
    InfoDestination.prototype.createClone = function () {
        return new InfoDestination(this.importer);
    };
    InfoDestination.onLegacyPasswordHash = function (importer, _parameterValue, _hasParameter) {
        importer.destination = new legacy_password_hash_destination_1.LegacyPasswordHashDestination(importer);
    };
    InfoDestination.onPasswordHash = function (importer, _parameterValue, _hasParameter) {
        importer.destination = new password_hash_destination_1.PasswordHashDestination(importer);
    };
    InfoDestination.onCategoryKeyword = function (_importer, _parameterValue, _hasParameter) {
    };
    InfoDestination.onCreatedKeyword = function (_importer, _parameterValue, _hasParameter) {
    };
    InfoDestination.onDescriptionKeyword = function (_importer, _parameterValue, _hasParameter) {
    };
    InfoDestination.onCreatorKeyword = function (_importer, _parameterValue, _hasParameter) {
    };
    InfoDestination.onKeywordsKeyword = function (_importer, _parameterValue, _hasParameter) {
    };
    InfoDestination.onLastModifiedByKeyword = function (_importer, _parameterValue, _hasParameter) {
    };
    InfoDestination.onLastPrintedKeyword = function (_importer, _parameterValue, _hasParameter) {
    };
    InfoDestination.onModifiedKeyword = function (_importer, _parameterValue, _hasParameter) {
    };
    InfoDestination.onRevisionKeyword = function (_importer, _parameterValue, _hasParameter) {
    };
    InfoDestination.onSubjectKeyword = function (_importer, _parameterValue, _hasParameter) {
    };
    InfoDestination.onTitleKeyword = function (_importer, _parameterValue, _hasParameter) {
    };
    InfoDestination.getStringDocumentPropertyDestinationBase = function (_importer, _setProperty) {
    };
    InfoDestination.getDateTimeDocumentPropertyDestinationBase = function (_importer, _setProperty) {
    };
    return InfoDestination;
}(destination_1.DestinationBase));
exports.InfoDestination = InfoDestination;
